import React from 'react';

import './table-background.css';

interface TableBackgroundProps {
    children: React.ReactNode;
}

function TableBackground(props: TableBackgroundProps) {
    const { children } = props;
    return <div className="table-background">{children}</div>;
}

export default TableBackground;
